
import React from 'react';
import { TermsAlert, AbsentStudentAlert } from '../components/FormAlerts';

interface FormAlertSectionProps {
  isPage1: boolean;
  isPage2: boolean;
  isTermsAccepted: boolean;
  isStudentAbsent: boolean;
}

const FormAlertSection: React.FC<FormAlertSectionProps> = ({
  isPage1,
  isPage2,
  isTermsAccepted,
  isStudentAbsent
}) => {
  return (
    <>
      <TermsAlert isPage1={isPage1} isTermsAccepted={isTermsAccepted} />
      <AbsentStudentAlert isPage2={isPage2} isStudentAbsent={isStudentAbsent} />
    </>
  );
};

export default FormAlertSection;
